import React from 'react';
import { AddTo } from '@thd-olt-component-react/add-to';
import { extend } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';

const { bool, number, string } = proptypes;

export const BuyboxAddToList = ({ itemId, itemPrice, quantity }) => {
  return (
    <AddTo
      addToType="List"
      products={[{ itemId, quantity, price: itemPrice }]}
    />
  );
};

BuyboxAddToList.dataModel = extend(
  AddTo
);

BuyboxAddToList.defaultProps = {
  quantity: 1
};

BuyboxAddToList.propTypes = {
  itemId: string.isRequired,
  itemPrice: number.isRequired,
  quantity: number
};
